import React from 'react';

import { Button } from '@components/Button';
import { GridForm } from '@components/NextForms/GridForm';
import { useSearch } from '@hooks/next/useSearch';
import { CommoditySearchQuery } from '@models/next/Commodity';
import { empty } from '@monoid-dev/mobx-zod-form';
import { useForm } from '@monoid-dev/mobx-zod-form-react';
import { useIsMobile } from '@styles';
import { formStrings } from '@utils/forms';

export const CommoditySearch: React.FC = () => {
  const { search, updateSearch } = useSearch(CommoditySearchQuery);

  const isMobile = useIsMobile();

  const form = useForm(CommoditySearchQuery, {
    initialOutput: search,
    enableReinitialize: true,
  });

  const { fields } = form.root;

  return (
    <form {...form.bindForm({ onSubmit: (v) => updateSearch({ ...v, page: 1 }) })}>
      <GridForm
        columns={isMobile ? 1 : 4}
        fields={[fields.commodity_no, fields.name_en]}
        buttons={
          <>
            <Button
              color="primary"
              size="small"
              type="submit"
              text={formStrings.search}
              style={{ width: 88 }}
            />
            <Button
              color="primary"
              size="small"
              type="submit"
              text={formStrings.reset}
              onClick={() => form.root.setOutput(empty)}
              style={{ width: 88 }}
            />
          </>
        }
      />
    </form>
  );
};
